var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.875C14.0711 16.875 15.75 15.1961 15.75 13.125C15.75 11.0539 14.0711 9.375 12 9.375C9.92893 9.375 8.25 11.0539 8.25 13.125C8.25 15.1961 9.92893 16.875 12 16.875Z",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 10.875C19.2485 10.8735 20.1103 11.0762 20.8916 11.4669C21.6729 11.8575 22.3521 12.4253 22.875 13.125",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.125 13.125C1.64794 12.4253 2.32714 11.8575 3.10843 11.4669C3.88972 11.0762 4.75149 10.8735 5.625 10.875",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6001 20.2502C7.09399 19.2387 7.86205 18.3863 8.81677 17.79C9.77148 17.1937 10.8745 16.8776 12.0001 16.8776C13.1257 16.8776 14.2287 17.1937 15.1834 17.79C16.1381 18.3863 16.9062 19.2387 17.4001 20.2502",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62487 10.875C5.05547 10.8756 4.49767 10.7141 4.01663 10.4094C3.5356 10.1048 3.1512 9.6695 2.90836 9.15449C2.66551 8.63947 2.57425 8.06598 2.64523 7.50102C2.71621 6.93607 2.9465 6.40298 3.3092 5.96404C3.6719 5.52511 4.15203 5.19845 4.69348 5.02225C5.23492 4.84605 5.81534 4.82758 6.3669 4.96899C6.91845 5.11041 7.41838 5.40587 7.80826 5.82085C8.19813 6.23583 8.46186 6.7532 8.56862 7.3125",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4312 7.3125C15.5379 6.7532 15.8016 6.23583 16.1915 5.82085C16.5814 5.40587 17.0813 5.11041 17.6329 4.96899C18.1844 4.82758 18.7648 4.84605 19.3063 5.02225C19.8477 5.19845 20.3279 5.52511 20.6906 5.96404C21.0533 6.40298 21.2836 6.93607 21.3545 7.50102C21.4255 8.06598 21.3343 8.63947 21.0914 9.15449C20.8486 9.6695 20.4642 10.1048 19.9831 10.4094C19.5021 10.7141 18.9443 10.8756 18.3749 10.875",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersThree);
export default __webpack_public_path__ + "static/media/UsersThree.45b5f140c93ebb1ae8dcf744436bcc7e.svg";
export { ForwardRef as ReactComponent };